// extracted by mini-css-extract-plugin
export var pathClass = "index-module--pathClass--224E4";
export var content = "index-module--content--2PbS9";
export var grayContent = "index-module--grayContent--3AjXS";